export const KEY_LEFT = 37;
export const KEY_RIGHT = 39;
export const KEY_UP = 38;
export const KEY_DOWN = 40;
export const KEY_ESC = 27;
export const KEY_SPACE = 32;
export const KEY_ENTER = 13;
export const KEY_BACKSPACE = 8;
export const KEY_TAB = 9;
export const KEY_PERIOD = 190;
export const KEY_PERIOD_NUMPAD = 110;
export function checkKeyIsValidInput(keyCode) {
  //Check if keyCode is [0..9] or if is [a..z] or backspace
  return keyCode >= 48 && keyCode <= 57 || keyCode >= 65 && keyCode <= 90 || keyCode === KEY_BACKSPACE;
}
export function checkKeyIsValidForTimestamp(keyCode) {
  //Check if keyCode is [0..9] or : or backspace, leftarrow, rightarrow, tab
  return keyCode >= 48 && keyCode <= 57 || keyCode === KEY_BACKSPACE || keyCode === KEY_LEFT || keyCode === KEY_RIGHT || keyCode === KEY_TAB || keyCode === 186;
}
export function checkKeyIsValidNumericInput(keyCode, allowDecimals = true) {
  //Check if keyCode is [0..9] or backspace or .
  // From 96 to 105 are the keycodes of [0..9] using numpad
  return keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105 || allowDecimals === true && (keyCode === KEY_PERIOD || keyCode === KEY_PERIOD_NUMPAD) || keyCode === KEY_BACKSPACE || keyCode === KEY_LEFT || keyCode === KEY_RIGHT || keyCode === KEY_TAB;
}
function removeCellFocus(event, template) {
  const container = template.querySelector('.container');
  if (container) {
    event.target.setAttribute('tabindex', '-1');
    container.setAttribute('tabindex', '0');
    container.focus();
  }
}
function moveToNextElement(event, row, column, template) {
  const targetElement = template.querySelector('[data-row="' + row + '"][data-column="' + column + '"]');
  if (targetElement) {
    event.target.setAttribute('tabindex', '-1');
    targetElement.setAttribute('tabindex', '0');
    targetElement.focus();
  }
}
function isInputElement(event) {
  return event.target.localName === 'lightning-input';
}
function isFocusedInputElement(event) {
  return event.target.localName === 'lightning-input' && event.target.focus;
}
function isEditableElement(event) {
  return !event.target.dataset.row && !event.target.dataset.column;
}
export function basicTableKeyboardNavigation(isKeyboardNavigationOn, existingRows, deleteColumn, removeRow, event, template) {
  const column = parseInt(event.target.dataset.column);
  const row = parseInt(event.target.dataset.row);
  let keyboardNavigation = isKeyboardNavigationOn;
  switch (event.keyCode) {
    case KEY_TAB:
      if (keyboardNavigation) {
        event.preventDefault();
        removeCellFocus(event, template);
        keyboardNavigation = false;
      }
      break;
    case KEY_ENTER:
      if (column !== undefined && column < deleteColumn) {
        event.target.children[0].focus();
        break;
      }
      if (column === deleteColumn) {
        removeRow(event);
        break;
      }
      if (isInputElement(event)) {
        event.target.parentNode.focus();
        break;
      }
      keyboardNavigation = true;
      moveToNextElement(event, 0, 0, template);
      break;
    case KEY_ESC:
      if (isInputElement(event)) {
        event.target.parentNode.focus();
        break;
      }
      event.preventDefault();
      if (keyboardNavigation) {
        removeCellFocus(event, template);
        keyboardNavigation = false;
      }
      break;
    case KEY_UP:
      if (isFocusedInputElement(event)) {
        return keyboardNavigation;
      }
      event.preventDefault();
      if (!isEditableElement(event) && row > 0) {
        moveToNextElement(event, row - 1, column, template);
      }
      break;
    case KEY_DOWN:
      if (isFocusedInputElement(event)) {
        return keyboardNavigation;
      }
      event.preventDefault();
      if (!isEditableElement(event) && row < existingRows) {
        moveToNextElement(event, row + 1, column, template);
      }
      break;
    case KEY_LEFT:
      if (isFocusedInputElement(event)) {
        return keyboardNavigation;
      }
      event.preventDefault();
      if (!isEditableElement(event) && column > 0) {
        moveToNextElement(event, row, column - 1, template);
      }
      break;
    case KEY_RIGHT:
      if (isFocusedInputElement(event)) {
        return keyboardNavigation;
      }
      event.preventDefault();
      if (!isEditableElement(event) && column < deleteColumn) {
        moveToNextElement(event, row, column + 1, template);
      }
      break;
    default:
  }
  return keyboardNavigation;
}